class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.page = 1;
    this.pageShowed = 1;
    this.firstLoad = true;
    this.cachedProducts = [];
    this.productShowed = 0;
    this.infinitScroll = false;
  }

  connectedCallback() {
    this.initGrid();
    this.init();
    this.getWidth();
  }

  initGrid() {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;
    this.gridName = '#product-grid';
    this.gridContainer = grid;
    if (!this.dataset.next) {
      document.getElementById('load-more-button')?.classList.add('d-none');
    }
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    const loadMoreButton = document.getElementById('load-more-button');
    if (!loadMoreButton) return;
    loadMoreButton.addEventListener('click', () => this.handleClickButton());

    if (this.cachedProducts.length <= 20) {
      this.page++;
      this.fetchNextPage(this.page);
    }
  }

  handleClickButton() {
    const button = document.getElementById('load-more-button');
    if (!button) return;
    if (button.dataset.infinit === 'true' && !this.infinitScroll) {
      this.enableInfinitScroll();
      button.classList.add('d-none');
    }
    this.displayMoreItems();
  }

  enableInfinitScroll() {
    window.addEventListener('scroll', () => this.onScroll(), { passive: true });
    this.infinitScroll = true;
  }

  onScroll() {
    if (this.loadingMore) return;
    const threshold = window.innerWidth < 768 ? 1200 : 800;
    const footer = document.querySelector('footer');
    if (!footer) return;
    if (footer.getBoundingClientRect().top <= window.innerHeight + threshold) {
      this.displayMoreItems();
    }
  }

  displayMoreItems() {
    if (this.cachedProducts.length === 0 && !this.checkToEnd()) return;
    this.loadingMore = true;

    const isEnded = this.checkToEnd();
    const button = document.getElementById('load-more-button');

    if (isEnded && this.cachedProducts.length < 24) {
      button?.classList.add('d-none');
      this.loadingMore = false;
      return;
    }

    this.disableButton();
    this.productShowed += 24;
    this.pageShowed++;

    const itemsToDisplay = this.cachedProducts.splice(0, 24);
    itemsToDisplay.forEach(item => {
      this.gridContainer.insertAdjacentHTML('beforeend', item);
    });

    this.getWidth();
    this.enableButton();
    this.buildModal();
    this.checkButtons();
    this.reloadWishlist();
    this.loadingMore = false;

    if (this.cachedProducts.length <= 24 && !isEnded) {
      this.page++;
      this.fetchNextPage(this.page);
    }
  }

  fetchNextPage(pageNumber) {
    const shopUrl = this.dataset.shopUrl || '';
    const url = `${shopUrl}/${this.dataset.next}`;
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.set('page', pageNumber);
    if (parsedUrl.searchParams.get('q')) {
      parsedUrl.searchParams.set('search', parsedUrl.searchParams.get('q'));
    }
    parsedUrl.searchParams.delete('phcursor');

    const isEnded = this.checkToEnd();
    if (isEnded || !this.dataset.next) {
      this._handleEndState();
      return;
    }

    fetch(parsedUrl.href, { method: 'GET', headers: { 'Content-Type': 'text/html' } })
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = doc.querySelector(this.gridName);
        if (grid) {
          const temp = document.createElement('div');
          temp.innerHTML = grid.innerHTML;
          this.cachedProducts.push(...Array.from(temp.children).map(el => el.outerHTML));
        }

        if (this.cachedProducts.length > 24 && this.firstLoad) {
          this.firstLoad = false;
          document.getElementById('big-spinner')?.classList.add('d-none');
          document.getElementById('load-more-button')?.classList.remove('d-none');
        }

        if (this.cachedProducts.length < 60) {
          this.page++;
          this.fetchNextPage(this.page);
        }
      })
      .catch(err => console.error('InfiniteScroll fetch error:', err));
  }

  _handleEndState() {
    if (this.cachedProducts.length <= 24 && this.cachedProducts.length > 0 && this.productShowed === 0) {
      this.displayMoreItems();
      document.getElementById('big-spinner')?.classList.add('d-none');
      document.getElementById('load-more-button')?.classList.add('d-none');
      document.getElementById('ProductCount')?.classList.add('d-none');
    } else if (this.productShowed === 0 && this.cachedProducts.length === 0) {
      document.getElementById('ProductCount')?.classList.add('d-none');
      if (!this.dataset.next) {
        // single-page collection — nothing to do
      } else {
        document.getElementById('no-items-available')?.classList.remove('d-none');
      }
    }
    document.getElementById('big-spinner')?.classList.add('d-none');
  }

  checkToEnd() {
    const bar = document.getElementById('chargedProductColored');
    if (!bar) return true;
    return this.page * 24 >= parseInt(bar.dataset.max) + 24;
  }

  buildModal() {
    if (typeof mainAddToCart === 'function') mainAddToCart();
  }

  getWidth() {
    const bar = document.getElementById('chargedProductColored');
    if (!bar) return;
    const width = (this.pageShowed * 24) / Number(bar.dataset.max) * 100;
    bar.style.width = width + '%';
  }

  checkButtons() {
    document.querySelectorAll('.quick-add__add-to-cart').forEach(button => {
      button.addEventListener('click', () => {
        if (typeof initializeVariantCheck === 'function') initializeVariantCheck(button);
      });
    });
  }

  disableButton() {
    const button = document.getElementById('load-more-button');
    if (!button) return;
    button.disabled = true;
    button.classList.add('showSpinner');
  }

  enableButton() {
    const button = document.getElementById('load-more-button');
    if (!button) return;
    button.disabled = false;
    button.classList.remove('showSpinner');
  }

  reloadWishlist() {
    const proxyPathDiv = document.getElementById('proxyPathDiv');
    const websiteCodeEl = document.querySelector('#websiteCode');
    if (!proxyPathDiv || !websiteCodeEl) return;

    document.querySelectorAll('.wishlist_fav').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const element = e.currentTarget;
        if (element.dataset.disabled === 'true') return;

        element.dataset.disabled = 'true';
        element.classList.add('is-loading');

        const body = {
          productId: element.dataset.productId,
          websiteCode: websiteCodeEl.dataset.id,
          action: element.dataset.action
        };

        try {
          const r = await fetch(proxyPathDiv.dataset.proxyPath + '/customer/wishlist', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          });

          if (r.ok) {
            const other = element.parentElement?.querySelector(
              `.wishlist_fav[data-action="${element.dataset.action === 'add' ? 'remove' : 'add'}"]`
            );
            if (other) {
              element.style.display = 'none';
              other.style.display = 'block';
            }
          }
        } catch (err) {
          console.error(err);
        } finally {
          element.dataset.disabled = 'false';
          element.classList.remove('is-loading');
          if (window.location.pathname.endsWith('/pages/wishlist')) {
            element.closest('.grid__item')?.remove();
          }
        }
      });
    });
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
